document.addEventListener('DOMContentLoaded', function() {
  var midProducts = document.getElementById('article-mid-products');
  var contentEl = document.querySelector('.post-content.rte');
  if (!midProducts || !contentEl) return;
  var headings = contentEl.querySelectorAll('h2, h3');
  var insertAfter = null;
  if (headings.length >= 3) {
    insertAfter = headings[Math.floor(headings.length / 2) - 1];
  } else if (headings.length >= 1) {
    insertAfter = headings[0];
  } else {
    var paragraphs = contentEl.querySelectorAll('p');
    if (paragraphs.length >= 4) {
      insertAfter = paragraphs[Math.floor(paragraphs.length / 2) - 1];
    }
  }
  if (insertAfter) {
    insertAfter.parentNode.insertBefore(midProducts, insertAfter.nextSibling);
  }
});